import React, { useState, useEffect } from "react";
import { usePipelineValueOverTime } from "@/entities/reporting/hooks";
import PipelineOverTime from "@/components/layouts/PipelineOverTime/PipelineOverTime";
import {
  PaginationDirection,
  PipelineMetric,
  PipelinePeriod
} from "@/components/layouts/PipelineOverTime/types";

const PipelineOverTimeWrapper: React.FC = () => {
  const [period, setPeriod] = useState<PipelinePeriod>(PipelinePeriod.MONTHLY);
  const [metric, setMetric] = useState<PipelineMetric>(PipelineMetric.VALUE);
  const [page, setPage] = useState<number>(0);

  const { data, isLoading, fetchData } = usePipelineValueOverTime(period, page);

  useEffect(() => {
    fetchData();
  }, [period, page, metric]);

  const handlePeriodChange = (newPeriod: PipelinePeriod) => {
    setPeriod(newPeriod);
    setPage(0);
  };

  const handleMetricChange = (newMetric: PipelineMetric) => {
    setMetric(newMetric);
  };

  const handleNavigate = (direction: PaginationDirection) => {
    if (!data?.pagination) return;

    if (
      direction === PaginationDirection.PREV &&
      data.pagination.prevPages > 0
    ) {
      setPage(page - 1);
    } else if (
      direction === PaginationDirection.NEXT &&
      data.pagination.nextPages > 0
    ) {
      setPage(page + 1);
    }
  };

  const canGoPrev = data?.pagination ? data.pagination.prevPages > 0 : false;
  const canGoNext = data?.pagination ? data.pagination.nextPages > 0 : false;

  return (
    <PipelineOverTime
      data={
        data?.pipelineOverTime
          ? { pipelineOverTime: data.pipelineOverTime }
          : undefined
      }
      isLoading={isLoading}
      period={period}
      onPeriodChange={handlePeriodChange}
      metric={metric}
      onMetricChange={handleMetricChange}
      onNavigate={handleNavigate}
      canGoPrev={canGoPrev}
      canGoNext={canGoNext}
    />
  );
};

export default PipelineOverTimeWrapper;
